import { Moment } from "moment";

export enum MetadataType {
  CLASS = 'CLASS',
  LANG = 'LANG',
  TRADEMARK = 'TRADEMARK',
  NICE_CLASS = 'NICE_CLASS',
  LOCATION = 'LOCATION',
  DATE = 'DATE',
  PERIOD = 'PERIOD',
  USER = 'USER',
  STORE_ORDER_POSSIBILITY = 'STORE_ORDER_POSSIBILITY',
  PRODUCT_SERVICE = 'PRODUCT_SERVICE',
  // crawler specific
  CRAWLER_PAGE_TITLE = 'CRAWLER_PAGE_TITLE',
  CRAWLER_BROWSER = 'CRAWLER_BROWSER',
  CRAWLER_USER_AGENT = 'CRAWLER_USER_AGENT',
  CRAWLER_URL = 'CRAWLER_URL',
  CRAWLER_SCREENSHOT_DATE = 'CRAWLER_SCREENSHOT_DATE',
  CRAWLER_WEBSITE_IP = 'CRAWLER_WEBSITE_IP',
  CRAWLER_OPERATING_SYSTEM = 'CRAWLER_OPERATING_SYSTEM',
  CRAWLER_VERSION = 'CRAWLER_VERSION',
  CRAWLER_SSL_CERTIFICATE = 'CRAWLER_SSL_CERTIFICATE',
  ORCHESTRATOR_VERSION = 'ORCHESTRATOR_VERSION',
}

export enum MetadataOrigin {
  CRAWLER = 'CRAWLER',
  ANALYZER = 'ANALYZER',
  MANUAL = 'MANUAL',
}

export interface SSLCertificateInfo {
  issuer: string;
  subject: string;
  validity: {
    from: string;
    to: string;
  };
  fingerprint: string;
  serialNumber: string;
}

export interface DocumentMetadata {
  _id?: string;
  type: MetadataType;
  value: string;
  document: string;
  manual: boolean;
  timestamping?: boolean;
  technical?: boolean;
  // Stated by a user without pointing at any zone of the document (PRODUCT-33)
  noEvidence?: boolean;
  confidence: number;
  origin?: MetadataOrigin;
  user?: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  };
  createdAt?: Moment;
  // Set by the frontend when viewing a document through a case context to
  // flag metadata that exists on the document but is outside the case scope
  // (kept visible but read-only).
  excluded?: boolean;
}


export interface DocumentMetadataAndEvidence {
  _id?: string;
  type: MetadataType;
  value: string;
  // Add the information without pointing at a zone of the document
  noEvidence?: boolean;
  evidence?: {
    page: number;
    start: number[]
    end: number[]
  }
}